import { render } from "./poFulfillment.vue?vue&type=template&id=1fdd54d0&scoped=true"
import script from "./poFulfillment.vue?vue&type=script&lang=js"
export * from "./poFulfillment.vue?vue&type=script&lang=js"

import "./poFulfillment.vue?vue&type=style&index=0&id=1fdd54d0&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fdd54d0"]])

export default __exports__